import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import {mapDispatchToProps} from "../mapDispatchToProps"
import withBaseComponent from "../withBaseComponent";
import ButtonLoading from "../common/ButtonLoading"

class AgreeTermOfUse extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.state = {
      isProcessing: false,
    };

    this.agree = this.agree.bind(this);
  }

  agree() {
    this.setState({isProcessing: true})
    this.props.sessionActions.agreeTerm().then(res => {
      let mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))
      mf_authorization.term_agreed = true;
      localStorage.setItem('mf_authorization', JSON.stringify(mf_authorization))
      this.setState({isProcessing: false})
      window.location.href = '/'
      return res
    })
  }

  render() {
    const { isProcessing } = this.state;

    return (
      <div className="login-container">
        <div className="text-center login-block term-of-use">
          <p className="line1">{i18n.t("oauth_authorize.agree_term.title")}</p>
          <p className="line2 align-left">
            {i18n.t("oauth_authorize.agree_term.desc1")}<a href="https://biz.moneyforward.com/agreement" target="_blank" rel="noopener noreferrer">{i18n.t("oauth_authorize.agree_term.desc2")}</a>{i18n.t("oauth_authorize.agree_term.desc3")}<button className="btn-link normal" type="button" onClick={() => this.props.history.push('/terms-of-use-agreement')}>{i18n.t("oauth_authorize.agree_term.desc4")}</button>{i18n.t("oauth_authorize.agree_term.desc5")}<br />
            {i18n.t("oauth_authorize.agree_term.desc6")}
          </p>
          <ButtonLoading text={i18n.t('oauth_authorize.agree_term.submit')} className="btn mfc-btn-blue medium" type="button" isProcessing={isProcessing} onClick={this.agree} />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreeTermOfUse)
